// frontend/src/utils/dateUtils.js
// 날짜 포맷팅을 위한 공통 유틸리티 함수
// Firestore Timestamp 또는 Date 객체를 받아 지역화된 문자열로 반환합니다.
export const formatDate = (timestamp, locale = 'default') => {
  if (!timestamp) return '';

  // Firestore Timestamp 객체이거나 Date 객체일 수 있음
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

  // 유효한 Date 객체인지 확인
  if (isNaN(date.getTime())) {
    console.error("Invalid date provided to formatDate:", timestamp);
    return '';
  }

  // 기본 옵션 (년, 월, 일)
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  // 시간 옵션 (시, 분)
  const timeOptions = { hour: '2-digit', minute: '2-digit' };

  // 날짜와 시간을 함께 포맷팅
  return `${date.toLocaleDateString(locale, dateOptions)} ${date.toLocaleTimeString(locale, timeOptions)}`;
};

// 날짜만 포맷팅하는 함수 (예: input type="date"에 사용)
export const formatOnlyDate = (timestamp) => {
  if (!timestamp) return '';

  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  if (isNaN(date.getTime())) {
    console.error("Invalid date provided to formatOnlyDate:", timestamp);
    return '';
  }

  // YYYY-MM-DD 형식으로 포맷팅 (input type="date"에 적합)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
export const formatTimeAgo = (timestamp) => {
    if (!timestamp) return '';
    const now = new Date();
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.error("Invalid date provided to formatTimeAgo:", timestamp);
      return '';
    }
    const seconds = Math.floor((now - date) / 1000);
    if (seconds < 60) return `${seconds}초 전`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}분 전`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}시간 전`;
    const days = Math.floor(hours / 24);
    return `${days}일 전`;
};

/**
 * 안전한 날짜 타임스탬프 변환 함수
 * Firestore Timestamp, Date 객체, 숫자, 문자열을 숫자 타임스탬프로 변환
 * @param {any} date - Firestore Timestamp, Date 객체, 숫자, 또는 문자열
 * @returns {number} 타임스탬프 (밀리초)
 */
export const getDateTimestamp = (date) => {
  if (!date) return Date.now();
  
  try {
    // Firestore Timestamp 객체인 경우
    if (date && typeof date.toDate === 'function') {
      const dateObj = date.toDate();
      if (dateObj instanceof Date && !isNaN(dateObj.getTime())) {
        return dateObj.getTime();
      }
    }
    
    // Date 객체인 경우
    if (date instanceof Date) {
      if (!isNaN(date.getTime())) {
        return date.getTime();
      }
    }
    
    // 숫자(타임스탬프)인 경우
    if (typeof date === 'number') {
      return date;
    }
    
    // 문자열인 경우
    if (typeof date === 'string') {
      const parsed = new Date(date);
      if (!isNaN(parsed.getTime())) {
        return parsed.getTime();
      }
    }
  } catch (error) {
    console.warn('⚠️ getDateTimestamp 오류:', error, date);
  }
  
  // 그 외의 경우 현재 시간 반환
  return Date.now();
};
